export default __webpack_public_path__ + "static/media/PTSerif-BoldItalic.318ae97b.ttf";